/**
 * Placeholders disponibles en las plantillas TD.
 *
 * El agente edita el texto con marcadores {{key}} en el editor. Al renderizar
 * el TD (visor público o vista compuesta) se sustituyen con los datos reales
 * de la reserva.
 *
 * Si un placeholder no tiene valor en la reserva, se muestra un espacio en
 * blanco (para que el agente lo detecte y complete o edite la plantilla).
 */

export const AVAILABLE_PLACEHOLDERS = [
  { key: "hora_encuentro",  label: "Hora de encuentro (18:30)" },
  { key: "fecha",           label: "Fecha del servicio (11 sept 2026)" },
  { key: "num_pax",         label: "Nº de viajeros (4 adultos)" },
  { key: "num_ad",          label: "Nº adultos" },
  { key: "num_ch",          label: "Nº niños" },
  { key: "ciudad",          label: "Ciudad" },
  { key: "pais",            label: "País" },
  { key: "main_traveler",   label: "Nombre del cliente principal" },
  { key: "servicio",        label: "Nombre del servicio" },
  { key: "proveedor",       label: "Proveedor" },
  { key: "duracion",        label: "Duración" },
  { key: "start_location",  label: "Punto de origen (transfer/self-drive)" },
  { key: "end_location",    label: "Punto de destino (transfer/self-drive)" },
];

/**
 * Sustituye placeholders {{key}} por los valores de `context`.
 * Placeholders sin valor: se dejan como "___" para que se vea el hueco.
 */
export function fillPlaceholders(text, context = {}) {
  if (!text) return text;
  return String(text).replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_, key) => {
    const v = context[key];
    if (v === undefined || v === null || v === "") return "___";
    return String(v);
  });
}

/**
 * Construye el contexto de sustitución a partir de una reserva + trip.
 */
export function buildContext({ reserva, trip }) {
  const r = reserva || {};
  const t = trip || {};
  const num_ad = r.num_ad || 0;
  const num_ch = r.num_ch || 0;
  const total = num_ad + num_ch;
  const num_pax = total > 0
    ? [num_ad ? `${num_ad} adulto${num_ad === 1 ? "" : "s"}` : "", num_ch ? `${num_ch} niño${num_ch === 1 ? "" : "s"}` : ""].filter(Boolean).join(" + ")
    : "";
  return {
    hora_encuentro: r.hour_entry || "",
    fecha: formatDate(r.date_entry) || "",
    num_pax,
    num_ad: num_ad || "",
    num_ch: num_ch || "",
    ciudad: r.city || "",
    pais: r.country || t.destination || "",
    main_traveler: t.titular_name || t.main_traveler || "",
    servicio: r.service || "",
    proveedor: r.provider_name || "",
    duracion: r.duration || "",
    start_location: r.start_location || "",
    end_location: r.end_location || "",
  };
}

function formatDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleDateString("en-US", { day: "numeric", month: "long", year: "numeric" });
  } catch { return ""; }
}
